module.exports = __webpack_public_path__ + "img/brush.e3d3f01a.svg";